/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CheckExtRecruitmentIdResponseDto } from '../models';
// @ts-ignore
import type { ProcessStatusDto } from '../models';
// @ts-ignore
import type { ProcessesCountResponseDto } from '../models';
// @ts-ignore
import type { ProcessesSearchResponseDto } from '../models';
// @ts-ignore
import type { ProcessesSortByDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * ProcessesSearchRestApi - axios parameter creator
 */
export const ProcessesSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if external recruitment id exists
         * @param {string} externalRecruitmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExtRecruitmentId: async (externalRecruitmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalRecruitmentId' is not null or undefined
            assertParamExists('checkExtRecruitmentId', 'externalRecruitmentId', externalRecruitmentId)
            const localVarPath = `/api/v1/processes/check-ext-recruitment-id/{externalRecruitmentId}`
                .replace(`{${"externalRecruitmentId"}}`, encodeURIComponent(String(externalRecruitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count recruitment processes for the provided user and statuses.
         * @summary Count recruitment processes by user and statuses
         * @param {string} userId 
         * @param {Array<ProcessStatusDto>} statuses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProcesses: async (userId: string, statuses: Array<ProcessStatusDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('countProcesses', 'userId', userId)
            // verify required parameter 'statuses' is not null or undefined
            assertParamExists('countProcesses', 'statuses', statuses)
            const localVarPath = `/api/v1/processes/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses.join(COLLECTION_FORMATS.csv);
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all recruitment processes, with optional filtering by name, ID, or date.
         * @summary Get a list of recruitment processes
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {ProcessesSortByDto} [sortBy] 
         * @param {Array<ProcessStatusDto>} [statuses] 
         * @param {string} [searchPhrase] 
         * @param {string} [externalProcessId] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [createdBy] 
         * @param {number} [ordinalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processesSearch: async (pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: ProcessesSortByDto, statuses?: Array<ProcessStatusDto>, searchPhrase?: string, externalProcessId?: string, dateFrom?: string, dateTo?: string, createdBy?: string, ordinalNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('processesSearch', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('processesSearch', 'page', page)
            const localVarPath = `/api/v1/processes/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses.join(COLLECTION_FORMATS.csv);
            }

            if (searchPhrase !== undefined) {
                localVarQueryParameter['searchPhrase'] = searchPhrase;
            }

            if (externalProcessId !== undefined) {
                localVarQueryParameter['externalProcessId'] = externalProcessId;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['createdBy'] = createdBy;
            }

            if (ordinalNumber !== undefined) {
                localVarQueryParameter['ordinalNumber'] = ordinalNumber;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesSearchRestApi - functional programming interface
 */
export const ProcessesSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check if external recruitment id exists
         * @param {string} externalRecruitmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkExtRecruitmentId(externalRecruitmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckExtRecruitmentIdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkExtRecruitmentId(externalRecruitmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesSearchRestApi.checkExtRecruitmentId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count recruitment processes for the provided user and statuses.
         * @summary Count recruitment processes by user and statuses
         * @param {string} userId 
         * @param {Array<ProcessStatusDto>} statuses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countProcesses(userId: string, statuses: Array<ProcessStatusDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessesCountResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countProcesses(userId, statuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesSearchRestApi.countProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all recruitment processes, with optional filtering by name, ID, or date.
         * @summary Get a list of recruitment processes
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {ProcessesSortByDto} [sortBy] 
         * @param {Array<ProcessStatusDto>} [statuses] 
         * @param {string} [searchPhrase] 
         * @param {string} [externalProcessId] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [createdBy] 
         * @param {number} [ordinalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processesSearch(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: ProcessesSortByDto, statuses?: Array<ProcessStatusDto>, searchPhrase?: string, externalProcessId?: string, dateFrom?: string, dateTo?: string, createdBy?: string, ordinalNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processesSearch(pageSize, page, sortOrder, sortBy, statuses, searchPhrase, externalProcessId, dateFrom, dateTo, createdBy, ordinalNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesSearchRestApi.processesSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesSearchRestApi - factory interface
 */
export const ProcessesSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesSearchRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Check if external recruitment id exists
         * @param {string} externalRecruitmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExtRecruitmentId(externalRecruitmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckExtRecruitmentIdResponseDto> {
            return localVarFp.checkExtRecruitmentId(externalRecruitmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Count recruitment processes for the provided user and statuses.
         * @summary Count recruitment processes by user and statuses
         * @param {string} userId 
         * @param {Array<ProcessStatusDto>} statuses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProcesses(userId: string, statuses: Array<ProcessStatusDto>, options?: RawAxiosRequestConfig): AxiosPromise<ProcessesCountResponseDto> {
            return localVarFp.countProcesses(userId, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all recruitment processes, with optional filtering by name, ID, or date.
         * @summary Get a list of recruitment processes
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {ProcessesSortByDto} [sortBy] 
         * @param {Array<ProcessStatusDto>} [statuses] 
         * @param {string} [searchPhrase] 
         * @param {string} [externalProcessId] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [createdBy] 
         * @param {number} [ordinalNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processesSearch(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: ProcessesSortByDto, statuses?: Array<ProcessStatusDto>, searchPhrase?: string, externalProcessId?: string, dateFrom?: string, dateTo?: string, createdBy?: string, ordinalNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessesSearchResponseDto> {
            return localVarFp.processesSearch(pageSize, page, sortOrder, sortBy, statuses, searchPhrase, externalProcessId, dateFrom, dateTo, createdBy, ordinalNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessesSearchRestApi - interface
 */
export interface ProcessesSearchRestApiInterface {
    /**
     * 
     * @summary Check if external recruitment id exists
     * @param {string} externalRecruitmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkExtRecruitmentId(externalRecruitmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckExtRecruitmentIdResponseDto>;

    /**
     * Count recruitment processes for the provided user and statuses.
     * @summary Count recruitment processes by user and statuses
     * @param {string} userId 
     * @param {Array<ProcessStatusDto>} statuses 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countProcesses(userId: string, statuses: Array<ProcessStatusDto>, options?: RawAxiosRequestConfig): AxiosPromise<ProcessesCountResponseDto>;

    /**
     * Retrieve all recruitment processes, with optional filtering by name, ID, or date.
     * @summary Get a list of recruitment processes
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {ProcessesSortByDto} [sortBy] 
     * @param {Array<ProcessStatusDto>} [statuses] 
     * @param {string} [searchPhrase] 
     * @param {string} [externalProcessId] 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {string} [createdBy] 
     * @param {number} [ordinalNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    processesSearch(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: ProcessesSortByDto, statuses?: Array<ProcessStatusDto>, searchPhrase?: string, externalProcessId?: string, dateFrom?: string, dateTo?: string, createdBy?: string, ordinalNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessesSearchResponseDto>;

}

/**
 * ProcessesSearchRestApi - object-oriented interface
 */
export class ProcessesSearchRestApi extends BaseAPI implements ProcessesSearchRestApiInterface {
    /**
     * 
     * @summary Check if external recruitment id exists
     * @param {string} externalRecruitmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkExtRecruitmentId(externalRecruitmentId: string, options?: RawAxiosRequestConfig) {
        return ProcessesSearchRestApiFp(this.configuration).checkExtRecruitmentId(externalRecruitmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count recruitment processes for the provided user and statuses.
     * @summary Count recruitment processes by user and statuses
     * @param {string} userId 
     * @param {Array<ProcessStatusDto>} statuses 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public countProcesses(userId: string, statuses: Array<ProcessStatusDto>, options?: RawAxiosRequestConfig) {
        return ProcessesSearchRestApiFp(this.configuration).countProcesses(userId, statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all recruitment processes, with optional filtering by name, ID, or date.
     * @summary Get a list of recruitment processes
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {ProcessesSortByDto} [sortBy] 
     * @param {Array<ProcessStatusDto>} [statuses] 
     * @param {string} [searchPhrase] 
     * @param {string} [externalProcessId] 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {string} [createdBy] 
     * @param {number} [ordinalNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public processesSearch(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: ProcessesSortByDto, statuses?: Array<ProcessStatusDto>, searchPhrase?: string, externalProcessId?: string, dateFrom?: string, dateTo?: string, createdBy?: string, ordinalNumber?: number, options?: RawAxiosRequestConfig) {
        return ProcessesSearchRestApiFp(this.configuration).processesSearch(pageSize, page, sortOrder, sortBy, statuses, searchPhrase, externalProcessId, dateFrom, dateTo, createdBy, ordinalNumber, options).then((request) => request(this.axios, this.basePath));
    }
}

